import DeliveryChallanList from '../components/DeliveryChallanList';

const PMDeliveryChallan = () => {
  return <DeliveryChallanList type="NON-JW" title="PM Delivery Challan" />;
};

export default PMDeliveryChallan;
